module.exports = __webpack_public_path__ + "img/partner6.a0338a87.png";